import type { Scenario, ProviderId } from "@/lib/powtoon-be/types";
import { liveavatarAdapter } from "./liveavatar/adapter";
import { tavusAdapter } from "./tavus/adapter";
import { didAdapter } from "./did/adapter";
import { kalturaAdapter } from "./kaltura/adapter";
import type { ScenarioAdapter } from "./types";

export type { ScenarioView, ScenarioAdapter, ScenarioFormState } from "./types";

/** Dispatch on `content.provider`. Unset defaults to `liveavatar`. */
export function getAdapter(scenario: Scenario): ScenarioAdapter {
  const provider = scenario.content?.provider ?? "liveavatar";
  return getAdapterByProvider(provider);
}

/** Same dispatch, keyed by provider id — used by the write path where
 *  the form knows the provider before any `Scenario` object exists. */
export function getAdapterByProvider(provider: ProviderId): ScenarioAdapter {
  switch (provider) {
    case "tavus":
      return tavusAdapter;
    case "did":
      return didAdapter;
    case "kaltura":
      return kalturaAdapter;
    case "liveavatar":
    default:
      return liveavatarAdapter;
  }
}

export function toScenarioView(scenario: Scenario) {
  return getAdapter(scenario).toView(scenario);
}

export function deriveScenarioThumbnail(scenario: Scenario): string | undefined {
  return getAdapter(scenario).deriveThumbnail(scenario);
}

/** Optional scene image behind the thumbnail (provider-specific). */
export function deriveScenarioBackground(scenario: Scenario): string | undefined {
  return getAdapter(scenario).deriveBackground?.(scenario);
}